import React from 'react'
import { useDevices } from './contexts/DevicesContext'
import { CloseButton, SectionTitle, Select, SidePanel } from './styles'
import { VIDEO_CALL_MEET_TEST_IDS } from './testIds'

interface Props {
  isOpen: boolean
  onClose: () => void
}

export default function DeviceSettingsModal({ isOpen, onClose }: Props) {
  const {
    devices,
    selectedCameraId,
    selectedMicrophoneId,
    changeCamera,
    changeMicrophone,
  } = useDevices()

  if (!isOpen) return null

  return (
    <SidePanel data-testid={VIDEO_CALL_MEET_TEST_IDS.devicePanel}>
      <SectionTitle data-testid={VIDEO_CALL_MEET_TEST_IDS.deviceSectionTitle}>
        Seus dispositivos
      </SectionTitle>
      <label
        data-testid={VIDEO_CALL_MEET_TEST_IDS.deviceCameraLabel}
        htmlFor="meet-camera-select"
      >
        Camera
      </label>
      <Select
        data-testid={VIDEO_CALL_MEET_TEST_IDS.deviceCameraSelect}
        id="meet-camera-select"
        value={selectedCameraId}
        onChange={(event) => {
          void changeCamera(event.target.value)
        }}
      >
        {devices.cameras.map((camera) => (
          <option key={camera.deviceId} value={camera.deviceId}>
            {camera.label || `Camera ${camera.deviceId.slice(0, 6)}`}
          </option>
        ))}
      </Select>

      <label
        data-testid={VIDEO_CALL_MEET_TEST_IDS.deviceMicLabel}
        htmlFor="meet-mic-select"
      >
        Microfone
      </label>
      <Select
        data-testid={VIDEO_CALL_MEET_TEST_IDS.deviceMicSelect}
        id="meet-mic-select"
        value={selectedMicrophoneId}
        onChange={(event) => {
          void changeMicrophone(event.target.value)
        }}
      >
        {devices.microphones.map((microphone) => (
          <option key={microphone.deviceId} value={microphone.deviceId}>
            {microphone.label || `Microfone ${microphone.deviceId.slice(0, 6)}`}
          </option>
        ))}
      </Select>

      <CloseButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.deviceClose}
        onClick={onClose}
      >
        Fechar
      </CloseButton>
    </SidePanel>
  )
}
